/* Publish by EComposer at 2026-10-21 14:11:59*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-fq8lw2dsbpj"]=  window.__ectimmers["ecom-fq8lw2dsbpj"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-fq8lw2dsbpj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fq8lw2dsbpj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ccz79n6yq99').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ccz79n6yq99', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ryrnnve0q3p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ryrnnve0q3p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u6iylezo9g9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u6iylezo9g9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h3c5kqw2r5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h3c5kqw2r5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uroo1c8ur5j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uroo1c8ur5j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8rd1tgg3i2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8rd1tgg3i2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xcvvvls9jq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xcvvvls9jq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-36zdqch3jzw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-36zdqch3jzw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0py1847dy8rc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0py1847dy8rc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y7kod3l8tj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y7kod3l8tj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m9ge8qyfoe9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m9ge8qyfoe9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-amp2ieg5sxr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-amp2ieg5sxr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ex486spesem').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ex486spesem', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3ylpkm1rar4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3ylpkm1rar4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c4icjj3evov').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c4icjj3evov', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pj03xzeohhe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pj03xzeohhe', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z992wkpvlq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z992wkpvlq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fvnkguczzj7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fvnkguczzj7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vbvsgmsgbi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vbvsgmsgbi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1xzgbjhqunz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1xzgbjhqunz', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vs8axvs000i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vs8axvs000i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1kvxgmj7pxu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1kvxgmj7pxu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fs3tuafjo2k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fs3tuafjo2k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bilttp5u42c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bilttp5u42c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zb3jm3bauh9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zb3jm3bauh9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hsyv68va618').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hsyv68va618', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-19h3oa3y6pni').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-19h3oa3y6pni', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-irzb4lvjn6i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-irzb4lvjn6i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a5wz2mip5rt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a5wz2mip5rt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nxxzfbmyq5t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nxxzfbmyq5t', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-inj7u2jr7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-inj7u2jr7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4bgny5jrf2e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4bgny5jrf2e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b0ixjself1w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b0ixjself1w', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nyvwci73wue').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nyvwci73wue', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s9kek0prpt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s9kek0prpt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-65esv8bssew').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-65esv8bssew', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3t1yhxj0ern').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3t1yhxj0ern', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-flvnq08pg7c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-flvnq08pg7c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mmfo781pt5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mmfo781pt5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nfzzhk7hfpc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nfzzhk7hfpc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7ibi57k3zgt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7ibi57k3zgt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lwxer0sz3yd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lwxer0sz3yd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gn10808fc6w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gn10808fc6w', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fqxv93dla6b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fqxv93dla6b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yta9tt2qbcj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yta9tt2qbcj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3v6u7hw3fau').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3v6u7hw3fau', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h6vxbwqjp0o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h6vxbwqjp0o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hakra9qjnxd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hakra9qjnxd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r95s99h0nb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r95s99h0nb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7ojkgx5bqge').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7ojkgx5bqge', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-huwnb53dlzo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-huwnb53dlzo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kguh9c2rbm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kguh9c2rbm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cdvs62qx8ek').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cdvs62qx8ek', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-embq7y70nbv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-embq7y70nbv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-03drcgoftrhv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-03drcgoftrhv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j9piltkikrg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j9piltkikrg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-021mbr7fgkxc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-021mbr7fgkxc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5zdq0pkranh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5zdq0pkranh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-14t6xia0qrx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-14t6xia0qrx', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v91rwbmntce').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v91rwbmntce', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-eh4u8b2oihi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-eh4u8b2oihi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dr7phjz7uwk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dr7phjz7uwk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zcwi2qmpbeg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zcwi2qmpbeg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cz4rug9c98p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cz4rug9c98p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-37m3tx93fal').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-37m3tx93fal', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-99ntvtz7to9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-99ntvtz7to9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oqvmfu3f0y').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oqvmfu3f0y', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6hmadujn5pk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6hmadujn5pk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9vv06l2o174').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9vv06l2o174', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iv0ivov6zxo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iv0ivov6zxo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e7x27359qn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e7x27359qn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mhbvm6wj5yg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mhbvm6wj5yg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5e4zveqhiip').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5e4zveqhiip', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kek48fg4zgh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kek48fg4zgh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g99ujg4hv7a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g99ujg4hv7a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qzdnlxyp3e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qzdnlxyp3e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ktl9z7nidj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ktl9z7nidj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hmrdgx8qye').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hmrdgx8qye', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7fuz1e0pwg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7fuz1e0pwg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gf0cqbuba7m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gf0cqbuba7m', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ihwayq8blfj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ihwayq8blfj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rouhxmgsu7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rouhxmgsu7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-10sh61quyyrn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-10sh61quyyrn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jcbs4rplmyc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jcbs4rplmyc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o94guzrexxl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o94guzrexxl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v7mn5b5cftp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v7mn5b5cftp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1ipu8wzuk3l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1ipu8wzuk3l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-allaigvd1t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-allaigvd1t', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wlmhpwvtuc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wlmhpwvtuc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7rdmj3djz6n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7rdmj3djz6n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wywq103zneb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wywq103zneb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tbnrzo3d3c8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tbnrzo3d3c8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-15h6b8jettp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-15h6b8jettp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8vol4x3ngdf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8vol4x3ngdf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tl7gg2x2dwf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tl7gg2x2dwf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qk0iyxreh7s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qk0iyxreh7s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-twud3bns0k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-twud3bns0k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5kflb9gu6bj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5kflb9gu6bj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hfv7yese9r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hfv7yese9r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8zskl4id2au').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8zskl4id2au', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-so3khyymh7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-so3khyymh7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ibygq0xdjh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ibygq0xdjh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ww4d9k3r7me').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ww4d9k3r7me', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tm5657zcur').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tm5657zcur', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5vjlyenxdo6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5vjlyenxdo6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uh31y3tewiq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uh31y3tewiq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-86gf9s0e3g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-86gf9s0e3g', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-9yw08w0dn5"]=  window.__ectimmers["ecom-9yw08w0dn5"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const s=t.querySelector(".ecom__element--button");if(!s)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,n=1e3;window.__ectimmers["ecom-9yw08w0dn5"]["5lropzwmk"] = setInterval(function(){s.classList.add("animated"),setTimeout(function(){s.classList.remove("animated")},n)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},s);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const n=e.getAttribute("href"),r=e.getAttribute("target");n&&n!=="#"&&n!=="javascript:void(0)"&&(r==="_blank"?window.open(n,"_blank"):setTimeout(function(){window.location.href=n},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-9yw08w0dn5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9yw08w0dn5', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ua3v6hcxqv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ua3v6hcxqv', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dfzgz65c739').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dfzgz65c739', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v6ggdm7p0n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v6ggdm7p0n', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fxoe1aab8sr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fxoe1aab8sr', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v8iafyobrk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v8iafyobrk', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jeob59rbf6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jeob59rbf6', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yohb8vpui4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yohb8vpui4', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s8i2rbp9n0i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s8i2rbp9n0i', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ll5usx3qtm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ll5usx3qtm', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rse8w4wxbk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rse8w4wxbk', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fgclw16wes5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fgclw16wes5', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k46exebwxtl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k46exebwxtl', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ozqo85grdlo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ozqo85grdlo', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q9di9qngwt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q9di9qngwt', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ekbjwddqlkt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ekbjwddqlkt', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ji8rqgjaude').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ji8rqgjaude', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s1qxvsm6vpe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s1qxvsm6vpe', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-65wo9q2sliw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-65wo9q2sliw', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-htfhk3351zv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-htfhk3351zv', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o9llnpeltqh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o9llnpeltqh', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-glvdk8chld').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-glvdk8chld', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4hevk9bzsak').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4hevk9bzsak', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qakblfpglg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qakblfpglg', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-28q8travbo6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-28q8travbo6', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jy7iro583h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jy7iro583h', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-km3unb15jho').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-km3unb15jho', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-naflz351zf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-naflz351zf', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jvws0gkzuvs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jvws0gkzuvs', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-dazveqs7akp"]=  window.__ectimmers["ecom-dazveqs7akp"] || {};
if(!this.settings||!this.$el)return;const t=this.$el,e=this.isLive,i=this.settings.loop,s=this.settings.autoplay,o=this.settings.lazyload||!1,n=this.settings.player_controls||!1,r=this.settings.pause_on_hover||!1,a=this.settings.click_to_play_pause,l=this.settings.play_on_lightbox||!1,c=1;let d=t.querySelector(".ecom-video_overlay-icon");const p=t.querySelector(".ecom-video-poster");let m;m=d&&d.querySelector(".ecom-video-icon-play");const _=t.querySelector(".ecom-element_video-iframe");o&&setTimeout(function(){b(_)},500);function b(A){let j={root:null,rootMargin:"0px",threshold:.5};new IntersectionObserver(w,j).observe(A)}function y(A,j){let P={handleMouseenter:T,handleMouseleave:I,handleEnded:D};function T(){A.readyState>=c&&A.pause()}function I(){A.readyState>=c&&A.play()}function D(){v(A,P)}if(r){A.addEventListener("mouseenter",T),A.addEventListener("mouseleave",I);let R=t.querySelector(".ecom-video_link-extra");R&&R.href&&(R.addEventListener("mouseenter",T),R.addEventListener("mouseleave",I)),j||A.addEventListener("ended",D)}}function v(A,j){if(j){const{handleMouseenter:P,handleMouseleave:T,handleEnded:I}=j;let D=t.querySelector(".ecom-video_link-extra");A.removeEventListener("mouseenter",P),A.removeEventListener("mouseleave",T),A.removeEventListener("ended",I),D&&D.href&&(D.removeEventListener("mouseenter",P),D.removeEventListener("mouseleave",T))}}function w(A,j){A.forEach(function(P){if(P.isIntersecting){const T=P.target.querySelector("video source"),I=P.target.querySelector("video"),D=P.target.querySelector("iframe");if(I&&T&&(T.src=T.dataset.source,I.load(),I.addEventListener("loadeddata",function(){s&&I.play()})),D){let R=D.dataset.srcVideo;D.setAttribute("src",R)}j.unobserve(P.target)}})}let S=t.querySelector(".ecom_video"),C=t.querySelector(".ecom_iframe");a&&S&&S.addEventListener("click",()=>{S.readyState>=c&&(S.paused?S.play():S.pause())}),s&&(d&&d.classList.remove("ecom-overlay"),m&&(m.style.display="none"),p&&(p.style.display="none")),S&&!i&&S.addEventListener("ended",function(){p&&(p.style.display="block"),d&&d.classList.add("ecom-overlay"),m&&(m.style.display="block")}),d&&d.addEventListener("click",()=>{if(this.settings.source=="hosted"||this.settings.source=="uploaded"&&S)p&&(p.style.display="none"),S.autoplay=!0,S.play(),d.classList.remove("ecom-overlay"),m.style.display="none";else if(C){let A=C.getAttribute("src");A.includes("autoplay=0")?A=A.replace("autoplay=0","autoplay=1"):A=A+"&autoplay=1",C.setAttribute("src",A),l?setTimeout(()=>{A=A.replace("autoplay=1","autoplay=0"),C.setAttribute("src",A)},100):(p&&(p.style.display="none"),d.classList.remove("ecom-overlay"),m.style.display="none")}}),S&&(e&&!p&&y(S,i),p&&p.addEventListener("click",function(){p.style.display="none",S.play(),e&&y(S,i)}),r||S.addEventListener("pause",function(){p&&(p.style.display="block"),d&&d.classList.add("ecom-overlay"),m&&(m.style.display="block")}),!n&&d&&S.addEventListener("click",function(){S.pause()})),t.querySelectorAll("[data-ec-tracking-id]").forEach(function(A){A.dataset.ecTrackingId&&A.addEventListener("click",function(){window.Shopify.analytics&&Shopify.analytics.publish("ec_custom_events",{button_id:A.id,tracking_id:A.dataset.ecTrackingId})},{once:!0})});const x=t.querySelector("[ecom-modal]"),$=function(A){if(window.EComModal)return A();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&A()});return}let j=0;const P= window.__ectimmers["ecom-dazveqs7akp"]["uys18dy62"] = setInterval(function(){window.EComModal?(clearInterval(P),A()):++j>=300&&clearInterval(P)},50)},E=this.id;x&&this.settings.image_overlay&&l&&$(function(){const A=x.dataset.width,j=x.dataset.height;var P=E;new window.EComModal(x,{cssClass:[P,"ecom-core","ecom-core-simulator"],onOpen:function(){var T=document.querySelector(".ecom-modal."+P);if(T){const I=T.querySelector(".ecom-modal-box__content");I.classList.add("ecom-element_video-iframe");const D={width:A,height:j};Object.assign(I.style,D)}},onClose:function(){var T=document.querySelector(".ecom-modal."+P);if(T){const I=T.querySelector(".ecom-element_video-iframe iframe");I&&(I.src="")}}})})

                    });
                    
                        document.querySelectorAll('.ecom-dazveqs7akp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dazveqs7akp', settings: {"loop":false,"autoplay":false,"lazyload":true,"player_controls":true,"click_to_play_pause":false,"play_on_lightbox":true,"source":"youtube","image_overlay":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9chvxvwra8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9chvxvwra8', settings: {"loop":false,"autoplay":false,"lazyload":true,"player_controls":true,"click_to_play_pause":false,"play_on_lightbox":true,"source":"youtube","image_overlay":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mdnnsplj2m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mdnnsplj2m', settings: {"loop":false,"autoplay":false,"lazyload":true,"player_controls":true,"click_to_play_pause":false,"play_on_lightbox":true,"source":"youtube","image_overlay":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d9cd6ku9z4b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d9cd6ku9z4b', settings: {"loop":false,"autoplay":false,"lazyload":true,"player_controls":true,"click_to_play_pause":false,"play_on_lightbox":true,"source":"youtube","image_overlay":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-581slndnh2r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-581slndnh2r', settings: {"loop":false,"autoplay":false,"lazyload":true,"player_controls":true,"click_to_play_pause":false,"play_on_lightbox":true,"source":"youtube","image_overlay":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-79ke602qal6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-79ke602qal6', settings: {"loop":false,"autoplay":false,"lazyload":true,"player_controls":true,"click_to_play_pause":false,"play_on_lightbox":true,"source":"youtube","image_overlay":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6fkf6en4j86').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6fkf6en4j86', settings: {"loop":false,"autoplay":false,"lazyload":true,"player_controls":true,"click_to_play_pause":false,"play_on_lightbox":true,"source":"youtube","image_overlay":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tbnt4z0smnj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tbnt4z0smnj', settings: {"loop":false,"autoplay":false,"lazyload":true,"player_controls":true,"click_to_play_pause":false,"play_on_lightbox":true,"source":"youtube","image_overlay":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kai1x31bq1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kai1x31bq1', settings: {"loop":false,"autoplay":false,"lazyload":true,"player_controls":true,"click_to_play_pause":false,"play_on_lightbox":true,"source":"youtube","image_overlay":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hppozb51nil').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hppozb51nil', settings: {"loop":false,"autoplay":false,"lazyload":true,"player_controls":true,"click_to_play_pause":false,"play_on_lightbox":true,"source":"youtube","image_overlay":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yg3hkdsnsw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yg3hkdsnsw', settings: {"loop":false,"autoplay":false,"lazyload":true,"player_controls":true,"click_to_play_pause":false,"play_on_lightbox":true,"source":"youtube","image_overlay":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jtuw6xuxt6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jtuw6xuxt6', settings: {"loop":false,"autoplay":false,"lazyload":true,"player_controls":true,"click_to_play_pause":false,"play_on_lightbox":true,"source":"youtube","image_overlay":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rsaqftk1cyp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rsaqftk1cyp', settings: {"loop":false,"autoplay":false,"lazyload":true,"player_controls":true,"click_to_play_pause":false,"play_on_lightbox":true,"source":"youtube","image_overlay":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ouvrcxuh499').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ouvrcxuh499', settings: {"loop":false,"autoplay":false,"lazyload":true,"player_controls":true,"click_to_play_pause":false,"play_on_lightbox":true,"source":"youtube","image_overlay":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-488in91jzhr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-488in91jzhr', settings: {"loop":false,"autoplay":false,"lazyload":true,"player_controls":true,"click_to_play_pause":false,"play_on_lightbox":true,"source":"youtube","image_overlay":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w9y668xu3rs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w9y668xu3rs', settings: {"loop":false,"autoplay":false,"lazyload":true,"player_controls":true,"click_to_play_pause":false,"play_on_lightbox":true,"source":"youtube","image_overlay":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pkkivo4mre').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pkkivo4mre', settings: {"loop":false,"autoplay":false,"lazyload":true,"player_controls":true,"click_to_play_pause":false,"play_on_lightbox":true,"source":"youtube","image_overlay":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pmlgdjcjl3h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pmlgdjcjl3h', settings: {"loop":false,"autoplay":false,"lazyload":true,"player_controls":true,"click_to_play_pause":false,"play_on_lightbox":true,"source":"youtube","image_overlay":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8d6i7nomdnc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8d6i7nomdnc', settings: {"loop":false,"autoplay":false,"lazyload":true,"player_controls":true,"click_to_play_pause":false,"play_on_lightbox":true,"source":"youtube","image_overlay":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qs1th0jul2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qs1th0jul2', settings: {"loop":false,"autoplay":false,"lazyload":true,"player_controls":true,"click_to_play_pause":false,"play_on_lightbox":true,"source":"youtube","image_overlay":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rsvxoky136').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rsvxoky136', settings: {"loop":false,"autoplay":false,"lazyload":true,"player_controls":true,"click_to_play_pause":false,"play_on_lightbox":true,"source":"youtube","image_overlay":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-isumdo83isk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-isumdo83isk', settings: {"loop":false,"autoplay":false,"lazyload":true,"player_controls":true,"click_to_play_pause":false,"play_on_lightbox":true,"source":"youtube","image_overlay":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1i6kvv5qkrgi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1i6kvv5qkrgi', settings: {"loop":false,"autoplay":false,"lazyload":true,"player_controls":true,"click_to_play_pause":false,"play_on_lightbox":true,"source":"youtube","image_overlay":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-eo9ubkuzvck').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-eo9ubkuzvck', settings: {"loop":false,"autoplay":false,"lazyload":true,"player_controls":true,"click_to_play_pause":false,"play_on_lightbox":true,"source":"youtube","image_overlay":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ipe03g8t4zb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ipe03g8t4zb', settings: {"loop":false,"autoplay":false,"lazyload":true,"player_controls":true,"click_to_play_pause":false,"play_on_lightbox":true,"source":"youtube","image_overlay":true},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}